import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TableCell } from '@components/ui/table-template/cells/table-cell';
import { TableTemplateColumnConfig } from '@components/ui/table-template/models/table-template-column-config';
import { DataViewModel } from '@components/ui/table-template/models/data-view-model';
import { DataViewModelValue } from '@components/ui/table-template/models/data-view-model-value';
import { CellClicked } from '@components/ui/table-template/models/cell-clicked';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-table-cell-button',
    templateUrl: './table-cell-button.component.html',
    styleUrls: ['./table-cell-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableCellButtonComponent implements TableCell {
  public readonly displayText = signal<string>('');
  public readonly buttonClickEvent = new Subject<CellClicked>();

  private emitValue: CellClicked | null = null;

  initialize(column: TableTemplateColumnConfig, row: DataViewModel, cell: DataViewModelValue): void {
    const button = cell as string;
    this.emitValue = { column, row, cell };
    this.displayText.set(button);
  }

  emit(): void {
    if (this.emitValue) {
      this.buttonClickEvent.next(this.emitValue);
    }
  }
}
